import { useMutation, UseMutationResult } from "@tanstack/react-query"
import { carrotClient } from "../../../utils/CarrotClient"
import { DoulaAttestationRequest } from "./doulaAttestationTypes"

export function useSendDoulaAttestation(): UseMutationResult<unknown, Error, DoulaAttestationRequest> {
  return useMutation<unknown, Error, DoulaAttestationRequest>((request) => carrotClient.sendDoulaAttestation(request), {
    retry: false
  })
}
